module.exports = __webpack_public_path__ + "img/icon-192x192.5df87526.png";